const LOG_PREFIX = "[Documents/FolderResolution]";

export const isDocumentFolderDebugEnabled = () => {
	if (typeof window === "undefined") return false;
	if (process.env.NODE_ENV === "development") return true;
	try {
		return window.localStorage?.getItem("DEBUG_DOCUMENTS_FOLDER") === "1";
	} catch (_) {
		return false;
	}
};

export const documentFolderDebug = (...args) => {
	if (!isDocumentFolderDebugEnabled()) return;
	console.log(LOG_PREFIX, ...args);
};

export const logAttachmentFolderFields = (context, attachments, extra = {}) => {
	if (!isDocumentFolderDebugEnabled()) return;

	const list = Array.isArray(attachments) ? attachments : [];
	console.group(`${LOG_PREFIX} ${context}`);
	console.log("extra:", extra);
	console.log("total:", list.length);
	list.forEach((attachment, index) => {
		documentFolderDebug(`attachment[${index}]`, {
			name: attachment?.name,
			url: attachment?.url,
			store_folder_id: attachment?.store_folder_id,
			folder_id: attachment?.folder_id,
			folder_name: attachment?.folder_name,
			store_folder: attachment?.store_folder,
			storeFolderId: attachment?.storeFolderId,
			folderId: attachment?.folderId,
			allKeys: attachment ? Object.keys(attachment) : [],
		});
	});
	console.groupEnd();
};

export const logFolderIdResolution = (context, attachment, details) => {
	if (!isDocumentFolderDebugEnabled()) return;

	documentFolderDebug(context, {
		document: attachment?.name,
		url: attachment?.url,
		...details,
	});
};
